import React from "react"
import TickingNumber from "./TickingNumber.jsx"
import useInView from "../hooks/useInView.js"
import { formatterFor, rawValueFor } from "../lib/format.js"

export default function CounterTile({ label, counter, size = "md" }) {
  const value = rawValueFor(counter)
  const format = formatterFor(counter?.unit)
  const [ref, inView] = useInView()

  const sizeClasses = {
    md: "text-[42px] tracking-[-0.035em] leading-none",
    lg: "text-[64px] tracking-[-0.045em] leading-[0.95]",
    xl: "text-[96px] tracking-[-0.05em] leading-[0.92]",
  }[size]

  return (
    <div ref={ref} className="flex flex-col gap-3">
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[color:var(--color-ink-tertiary)]">
        {label}
      </p>
      <p className={`font-sans font-medium text-[color:var(--color-ink-primary)] ${sizeClasses}`}>
        <TickingNumber value={value} format={format} armed={inView} />
      </p>
    </div>
  )
}
